export default __webpack_public_path__ + "static/service_window@2x-da320ff78eca8c826a0b993a7d322369.jpg";